import { createStore } from 'vuex';
import auth from './auth';
import utils from './modules/utils'

const store = createStore({
  modules: {
    auth,
    utils
  }
});

export default store;